import React, { memo } from 'react';
import { useTheme } from 'styled-components';
import { Tooltip } from '@web-chat-core/ui-kit';
import { ActiveSpeakerButtonView, ActiveSpeakerIcon } from './view';

export interface FloatActiveSpeakerButtonProps {
    onClick(e: React.MouseEvent<HTMLElement>): void;
    className?: string;
    hidden?: boolean;
    tooltip?: string;
}

export const FloatActiveSpeakerButton: React.FC<FloatActiveSpeakerButtonProps> = memo(
    ({ className, onClick, hidden, tooltip }) => {
        const theme = useTheme();

        return (
            <Tooltip label={tooltip}>
                <ActiveSpeakerButtonView onClick={onClick} className={className} $hidden={hidden}>
                    <ActiveSpeakerIcon icon="icExpand" size={24} color={theme.root.colors.basicColors['90%']} />
                </ActiveSpeakerButtonView>
            </Tooltip>
        );
    },
);

FloatActiveSpeakerButton.displayName = 'FloatActiveSpeakerButton';
